// BrokerList.styled.jsx
// Refactored for MUI v5 using the sx prop pattern or styled components.
// We export a styles object that can be spread into the sx prop.

const styles = {
  container: {
    width: '100%',
    margin: 0,
    padding: 0,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    textAlign: 'center',
    padding: '0',
  },
  tabContent: {},
  customRootClass: {
    boxShadow: 'none',
  },
  tab: {
    padding: '25px 35px 20px',
  },
  description: {
    lineHeight: 1,
    marginTop: '0px',
    marginBottom: '15px',
  },
  stepperContainer: {
    margin: '0 auto',
    maxWidth: 700,
  },
  activeStatus: (theme) => ({
    color: theme.palette.success.main,
    textTransform: 'capitalize',

    '&::first-letter': {
      textTransform: 'uppercase',
    },
  }),
};

export default styles;
